import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login.component';
import { ChangePasswordComponent } from './auth/change-password.component';
import { CatalogComponent } from './catalog/catalog.component';
import { ImportCommitComponent } from './import/import-commit.component';
import { ImportMapComponent } from './import/import-map.component';
import { ImportUploadComponent } from './import/import-upload.component';
import { ImportValidateComponent } from './import/import-validate.component';
import { ImportVmAuthComponent } from './import/import-vm-auth.component';
import { LogsComponent } from './logs/logs.component';
import { ReservationsBulkComponent } from './reservations/reservations-bulk.component';
import { ReservationsComponent } from './reservations/reservations.component';
import { ReservationExportComponent } from './reservation-export/reservation-export.component';
import { SettingsCommunicationComponent } from './settings/settings-communication.component';
import { PropertyAdministrationComponent } from './settings/property-administration.component';
import { UserCreateComponent } from './users/user-create.component';
import { UsersComponent } from './users/users.component';
import { adminGuard } from './core/admin.guard';
import { authGuard } from './core/auth.guard';
import { propertyContextGuard } from './core/property-context.guard';
import { propertyVmGuard } from './core/property-vm.guard';
import { PropertiesComponent } from './properties/properties.component';

export const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'properties', component: PropertiesComponent, canActivate: [authGuard] },
  { path: 'account/password', component: ChangePasswordComponent, canActivate: [authGuard] },
  { path: 'reservations', component: ReservationsComponent, canActivate: [authGuard, propertyContextGuard] },
  { path: 'reservations/bulk', component: ReservationsBulkComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'bulk' } },
  { path: 'reservation-export', component: ReservationExportComponent, canActivate: [authGuard, adminGuard, propertyContextGuard] },
  { path: 'import', pathMatch: 'full', redirectTo: 'import/upload' },
  { path: 'import/upload', component: ImportUploadComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'map' } },
  { path: 'import/vm-auth', component: ImportVmAuthComponent, canActivate: [authGuard] },
  { path: 'import/map', component: ImportMapComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'map' } },
  { path: 'import/validate', component: ImportValidateComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'map' } },
  { path: 'import/commit', component: ImportCommitComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'map' } },
  { path: 'settings', pathMatch: 'full', redirectTo: 'settings/communication' },
  { path: 'settings/communication', component: SettingsCommunicationComponent, canActivate: [authGuard] },
  { path: 'settings/property-administration', component: PropertyAdministrationComponent, canActivate: [authGuard] },
  { path: 'catalog', component: CatalogComponent, canActivate: [authGuard, propertyContextGuard, propertyVmGuard], data: { vmNext: 'catalog' } },
  { path: 'logs', component: LogsComponent, canActivate: [authGuard, propertyContextGuard] },
  { path: 'users', component: UsersComponent, canActivate: [authGuard] },
  { path: 'users/new', component: UserCreateComponent, canActivate: [authGuard] },
  { path: '', pathMatch: 'full', redirectTo: 'properties' },
];
